import {
  SETUP_LAYOUT_EDIT_SET_CURRENT_LAYOUT,
} from '../actionType';

const layout = (state = {
  id: '',
  name: '',
}, action) => {
  const { type, ...payload } = action;
  switch (type) {
    case SETUP_LAYOUT_EDIT_SET_CURRENT_LAYOUT:
      return Object.assign({}, state, { ...payload });
    default:
      return state;
  }
};

export default layout;



// WEBPACK FOOTER //
// ./src/views/Setup/PageLayout/flow/edit/reducers/layout.js